import { render, staticRenderFns } from "./newSeelogistics.vue?vue&type=template&id=8f78778a"
import script from "./newSeelogistics.vue?vue&type=script&lang=js"
export * from "./newSeelogistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports